import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=c0b5e2ac&"
import script from "./Liquid.vue?vue&type=script&lang=js&"
export * from "./Liquid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports